import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import LoaderComponent from '@components/LoaderComponent';

import {
	getSearchValueForSimilarProducts,
	sourceType,
	trackMixPanelStyleEvent
} from '@features/trend-research/utils/utils';
import { useFetchTrendExploreProductsMutation } from '@features/trend-research/api/onboardingApi';
import useTrendResearchFilterParams from '@features/trend-research/hooks/useTrendResearchFilterParams';
import Tags from '@features/trend-research/components/common/Tags';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

const SimilarProduct = ({ singleProduct, typeOfSource }) => {
	const dispatch = useDispatch();
	const [similarProducts, setSimilarProducts] = useState([]);
	const [totalElement, seTotalElement] = useState(0);
	const [fetchTrendExploreProducts, { data, isLoading }] = useFetchTrendExploreProductsMutation();
	const { requestBody } = useTrendResearchFilterParams();

	const debounce = useDebouncedCallback((offset) => {
		const source = sourceType[typeOfSource];
		const search = source === 'BRAND' ? getSearchValueForSimilarProducts(singleProduct) : null;
		fetchTrendExploreProducts({
			source: source,
			queryParams: `?page=${offset}&size=20${search ? '&k=500' : ''}`,
			requestBody: {
				categoryIdList: singleProduct?.categoryId ? [singleProduct.categoryId] : [],
				search: search
			}
		});
	}, 100);

	useEffect(() => {
		setSimilarProducts(data?.data || []);
		seTotalElement(data?.totalElements || 0);
	}, [data]);

	const fetchProducts = async (offset = 0) => {
		try {
			dispatch(openLoader());
			debounce(offset);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchProducts();
	}, [requestBody]);

	const handleRoute = () => {
		const newUrl = `/trends/similar-products`;
		sessionStorage.setItem('selectedItem', JSON.stringify({ ...singleProduct, source: typeOfSource }));
		trackMixPanelStyleEvent(singleProduct, typeOfSource, 'TRENDS_VIEW_ALL_ON_CLICK');
		window.open(newUrl, '_blank');
	};

	return (
		<LoaderComponent loading={isLoading}>
			<div className="trending-product similar-product border-0">
				<div className="section-title d-flex align-items-center justify-content-between pb-3">
					<p className="medium-14 gray_dark_01">View Similar Products ({totalElement})</p>
					<p onClick={handleRoute} className="medium-14 gray_dark_01 cursor-pointer">
						View all
					</p>
				</div>
				<div className="all-products-item">
					{similarProducts.length > 0 &&
						similarProducts?.slice(0, 4).map((singleProduct, index) => (
							<div key={index} className="single-design-card trend-product-card">
								<div className="card-top">
									<img src={singleProduct.imageUrl} alt="card-image" />
									{singleProduct?.isBestseller && (
										<Tags label="Bestseller" className="yellow-3" />
									)}
									{!singleProduct?.isBestseller && singleProduct?.isNewArrival && (
										<Tags label="New" className="blue-3" />
									)}
								</div>
							</div>
						))}
				</div>
			</div>
		</LoaderComponent>
	);
};

export default SimilarProduct;
